interface MobileFrameProps {
  children: React.ReactNode;
}

export default function MobileFrame({ children }: MobileFrameProps) {
  return (
    <div className="relative" style={{ width: '206px', height: '447px' }}>
      <div
        className="absolute top-0 left-0 origin-top-left overflow-hidden bg-white"
        style={{
          width: '375px',
          height: '812px',
          transform: 'scale(0.55)',
          borderRadius: '40px',
          boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
          border: '8px solid #1B2831',
        }}
      >
        {children}
      </div>
    </div>
  );
}
